/*global localStorage  */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let ProOnly = require("../../../../../widgets/ProOnly");
let SearchAContactService = require("./SearchAContactService");

module.exports = dd.createClass({
  getInitialState: function () {
    return { show_modal: false };
  },
  __openModal: esUtils.wrapPreventDefault(function () {
    this.setState({ show_modal: true });
  }),
  __onClose: esUtils.wrapPreventDefault(function () {
    this.setState({ show_modal: false });
  }),
  render: function () {
    let event = this.props.event;
    let defaultGrabservice = localStorage.getItem("default_grab_service");
    defaultGrabservice = _.isEmpty(defaultGrabservice)
      ? "EP"
      : defaultGrabservice;

    return dd.div(
      { className: "ContactGrabber" },
      ProOnly(
        { sids: _.get(event, "sids", []) },
        dd.a({ href: "#", onClick: this.__openModal }, "GRAB a crm contact")
      ),
      this.state.show_modal
        ? SearchAContactService({
            service: defaultGrabservice,
            event: event,
            onClose: this.__onClose,
          })
        : null
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/contacts/ContactGrabber/index.js